import React from 'react';
import { useReveal } from '../lib/useReveal';
import { CheckIcon, XIcon } from '../lib/icons';
const COMPARISON_DATA = [{
  situation: 'Tu familia reactiva lo que trabajaste',
  without: 'Volvés al patrón anterior sin entender por qué',
  with: 'Protocolo de blindaje listo. Sabés exactamente qué hacer.'
}, {
  situation: 'Empezás a ganar más y aparece el miedo',
  without: 'El techo genealógico se activa solo',
  with: 'Herramienta de desprogramación del límite de abundancia'
}, {
  situation: 'Sentís síntomas físicos después del trabajo emocional',
  without: 'No sabés si es normal o qué significa',
  with: 'Mapa de síntomas residuales con protocolo de respuesta'
}, {
  situation: 'Querés sostener el cambio a largo plazo',
  without: 'La nueva identidad se diluye en semanas',
  with: 'Sistema anual de soberanía con práctica guiada'
}, {
  situation: 'La presión familiar vuelve con fuerza',
  without: 'Cedés o explotas — no hay término medio',
  with: 'Scripts de respuesta para cada escenario de presión familiar'
}];
export function ComparisonSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#2D1B1B] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-75">
      <div className="container mx-auto max-w-4xl" data-id="element-76">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-77">
          <div className="text-center mb-10" data-id="element-78">
            <h2 className="text-2xl md:text-4xl font-bold text-[#F5ECD7] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-79">
              🌹 ¿QUÉ AGREGA EL PROTOCOLO DE SOBERANÍA TOTAL?
            </h2>
          </div>

          <div className="bg-[#1C1410] rounded-2xl border border-[#C9A96E]/20 overflow-hidden shadow-xl" data-id="element-80">
            {/* Header */}
            <div className="grid grid-cols-1 md:grid-cols-3 bg-[#2D1B1B]/50 border-b border-[#C9A96E]/20" data-id="element-81">
              <div className="p-4 md:p-5 hidden md:block" data-id="element-82">
                <span className="text-[#FAF3E8] font-bold text-sm uppercase tracking-wider" data-id="element-83">
                  Situación
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-b md:border-b-0 md:border-l border-[#C9A96E]/20 bg-[#8B2635]/10" data-id="element-84">
                <span className="text-[#C4856A] font-bold text-sm uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-85">
                  <XIcon className="w-4 h-4" data-id="element-86" /> Sin Protocolo
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-b md:border-b-0 md:border-l border-[#C9A96E]/20 bg-[#C9A96E]/10" data-id="element-87">
                <span className="text-[#C9A96E] font-bold text-sm uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-88">
                  <CheckIcon className="w-4 h-4" strokeWidth={3} data-id="element-89" /> Con
                  Protocolo
                </span>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-[#C9A96E]/10" data-id="element-90">
              {COMPARISON_DATA.map((row, idx) => <div key={idx} className="grid grid-cols-1 md:grid-cols-3 hover:bg-[#F5ECD7]/[0.02] transition-colors" data-id="element-91">
                  <div className="p-4 md:p-5 flex items-center" data-id="element-92">
                    <span className="text-[#F5ECD7] font-medium text-sm md:text-base" data-id="element-93">
                      {row.situation}
                    </span>
                  </div>
                  <div className="p-4 md:p-5 md:border-l border-[#C9A96E]/10 flex items-center justify-center text-center bg-[#8B2635]/5" data-id="element-94">
                    <span className="text-[#D4A5A5] text-sm" data-id="element-95">
                      {row.without}
                    </span>
                  </div>
                  <div className="p-4 md:p-5 md:border-l border-[#C9A96E]/10 flex items-center justify-center text-center bg-[#C9A96E]/5" data-id="element-96">
                    <span className="text-[#C9A96E] font-medium text-sm" data-id="element-97">
                      {row.with}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}